import { defaultHttpClient } from '../../httpClient';
import type { PostNaverLoginRequest, PostNaverLoginResponse } from './types';

/**
 * - 네이버 access_token으로 로그인하는 API
 * - 성공 시 멤버 JWT 토큰(token)을 반환한다.
 */
export const postNaverLogin = (params: PostNaverLoginRequest) => {
  return defaultHttpClient
    .request<PostNaverLoginResponse>({
      method: 'POST',
      url: '/api/v2/login/naver/',
      data: params,
    })
    .then(result => result.data);
};
